import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileMagnifyingGlass = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 96,
	height: 96,
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2389_212)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9 24.125L3.18418 25.3366C1.32931 25.7231 0 27.3578 0 29.2525V91.0808C0 93.618 2.33189 95.5142 4.81581 94.9967L44.8158 86.6634C46.6707 86.2769 48 84.6421 48 82.7474V80.3393L47 80.5357V82.7474C47 84.1685 46.003 85.3946 44.6119 85.6844L4.61186 94.0177C2.74892 94.4058 1 92.9837 1 91.0808V29.2525C1 27.8315 1.99698 26.6054 3.38814 26.3156L9 25.1465V24.125Z",
				fill: "white",
				fillOpacity: .94
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9 16.8661L8.25437 17.0076C6.36644 17.3658 5 19.0159 5 20.9375V87.1698C5 89.6778 7.28152 91.5672 9.74563 91.0997L57.7456 81.9925C59.6336 81.6343 61 79.9842 61 78.0626V77.7858L13.771 87.0629C11.2996 87.5484 9 85.6565 9 83.1379V16.8661ZM57.224 7.83496C59.0139 7.93229 60.5421 9.2335 60.9138 10.9976L57.224 7.83496Z",
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 13,
				cy: 15,
				r: 1,
				fill: "white",
				fillOpacity: .12
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 17,
				cy: 14.5,
				r: 1,
				fill: "white",
				fillOpacity: .12
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 21,
				cy: 13.5,
				r: 1,
				fill: "white",
				fillOpacity: .12
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.3254 63.1503C26.1167 60.8983 28.3638 56.5545 31.0224 57.196C34.3456 57.9978 19.6285 69.1047 25.3254 67.498C31.0224 65.8913 36.7193 57.0385 39.0931 57.2386C41.4668 57.4386 31.0224 69.3694 39.5678 61.7422C46.4041 55.6404 50.6452 52.6279 51.9112 51.8844",
				stroke: "#8588D8",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M50.0137 3.81092C49.7717 3.80008 49.5269 3.81851 49.2845 3.86756L12.405 11.3313C11.0059 11.6144 10.0001 12.8442 10.0001 14.2717L10.0001 83.1379C10.0001 85.0269 11.7248 86.4458 13.5783 86.0817L61.5783 76.6531C62.9853 76.3767 64.0001 75.1433 64.0001 73.7094L64.0001 65.0273C64.3229 65.2357 64.6565 65.4289 65.0001 65.6064L65.0001 73.7094C65.0001 75.6213 63.6471 77.2659 61.7711 77.6344L13.7711 87.0629C11.2997 87.5484 9.00007 85.6565 9.00007 83.1379L9.00007 14.2717C9.00007 12.3684 10.3412 10.7287 12.2066 10.3511L49.0861 2.88743C50.294 2.64299 51.5471 2.96893 52.4827 3.77092L65.0001 14.5001L65.0001 38.2158C64.6564 38.5275 64.3228 38.851 64.0001 39.1854L64.0001 15.0001L54.8224 15.0001C52.4166 15.0001 50.4363 13.1078 50.327 10.7044L50.0137 3.81092ZM62.8802 14.0001L54.8224 14.0001C52.9512 14.0001 51.411 12.5283 51.326 10.659L51.0249 4.03518C51.3151 4.15502 51.5879 4.32101 51.8319 4.53018L62.8802 14.0001Z",
				fill: "#A8AAE3"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M74.1643 64.6692C82.2676 62.9468 88.7252 54.8357 88.5879 46.5525C88.4505 38.2694 81.7702 32.9509 73.6669 34.6733C65.5637 36.3957 59.1061 44.5068 59.2434 52.7899C59.3808 61.073 66.0611 66.3915 74.1643 64.6692ZM74.1809 65.669C82.8244 63.8318 89.7125 55.18 89.566 46.3446C89.4195 37.5093 82.2938 31.8362 73.6504 33.6734C65.0069 35.5106 58.1188 44.1625 58.2653 52.9978C58.4118 61.8331 65.5375 67.5062 74.1809 65.669Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M74.1643 65.6694C82.2675 63.947 88.7251 55.8359 88.5878 47.5528C88.4504 39.2697 81.7701 33.9511 73.6669 35.6735C65.5636 37.3959 59.106 45.507 59.2434 53.7901C59.3807 62.0733 66.061 67.3918 74.1643 65.6694ZM74.1809 66.6693C82.8243 64.832 89.7124 56.1802 89.5659 47.3449C89.4194 38.5095 82.2938 32.8364 73.6503 34.6737C65.0068 36.5109 58.1187 45.1627 58.2652 53.998C58.4117 62.8334 65.5374 68.5065 74.1809 66.6693Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("g", {
				clipPath: "url(#clip1_2389_212)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M74.0124 54.5038C74.6873 54.3604 75.2444 54.8039 75.2558 55.4938C75.2672 56.1837 74.7288 56.86 74.0538 57.0035C73.3789 57.1469 72.8219 56.7034 72.8104 56.0135C72.799 55.3236 73.3375 54.6473 74.0124 54.5038ZM73.7775 40.3391C76.4788 39.7649 78.7054 41.5376 78.7512 44.2989C78.7811 46.1028 78.1828 47.1706 76.6395 48.8641C75.0914 50.5619 74.7764 51.2452 74.7999 52.6641L73.1696 53.0106C73.1355 50.9493 73.7601 49.7955 75.5629 47.8186C76.7816 46.4818 77.1407 45.8402 77.1209 44.6454C77.0904 42.804 75.6066 41.6226 73.8052 42.0055C72.0037 42.3884 70.5694 44.19 70.5999 46.0315L70.6137 46.8647L68.9835 47.2112L68.9697 46.378C68.9239 43.6167 71.0762 40.9133 73.7775 40.3391Z",
					fill: "white",
					fillOpacity: .94
				})
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 40,
				height: 1,
				transform: "matrix(0.978148 -0.207912 0 1 17 33.3164)",
				fill: "white",
				fillOpacity: .94
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 1,
				transform: "matrix(0.978148 -0.207912 0 1 24.8252 34.6531)",
				fill: "white",
				fillOpacity: .94
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M82.3342 68.7866C82.4375 68.7292 82.5442 68.6759 82.6542 68.6269C82.8549 68.5376 83.059 68.4661 83.2648 68.4118L80.4471 62.7764L79.5527 63.2236L82.3342 68.7866Z",
				fill: "white",
				fillOpacity: .94
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M91.0891 80.1964L87.0218 71.0609C86.3479 69.5473 84.5745 68.8666 83.0609 69.5405C81.5473 70.2144 80.8666 71.9877 81.5405 73.5014L85.6079 82.6368C86.2818 84.1504 88.0551 84.8311 89.5687 84.1572C91.0823 83.4833 91.763 81.71 91.0891 80.1964ZM82.6542 68.627C80.636 69.5255 79.7284 71.8899 80.6269 73.9081L84.6943 83.0435C85.5929 85.0617 87.9573 85.9693 89.9754 85.0708C91.9936 84.1722 92.9012 81.8078 92.0027 79.7896L87.9353 70.6542C87.0368 68.636 84.6723 67.7284 82.6542 68.627Z",
				fill: "white",
				fillOpacity: .94
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M85 82.5L88.5 79.5",
				stroke: "white",
				strokeOpacity: .94,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M83 78L86.5 75",
				stroke: "white",
				strokeOpacity: .94,
				strokeLinecap: "round"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2389_212",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 96,
			height: 96,
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_2389_212",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white",
			transform: "matrix(0.978148 -0.207912 0.0165799 0.999863 63.9684 40.7517)"
		})
	})] })]
});
export default SvgFileMagnifyingGlass;
